// extracted by mini-css-extract-plugin
module.exports = {"spin-wrapper":"__0z2lZAUr","turn":"__9yBqQTnc","infiniteRotating":"IJOGYwFW","fadeInOpacity":"zmGEAolC"};